import { useEffect, useState } from "react";
import Loader from "../CommerceManager/component/Loader";
import { useSelector } from "react-redux";
import domain from "../reusecomponent/domain";
import { ErrorToastContainer } from "../whatsapp/function/CustomFunction";
import { ReviewCard } from "./ReviewCard";

export default function ReviewList() {
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [selectedGmb, setSelectedGmb] = useState("");

  const Accesstoken = useSelector((state) => state.Token.value);

  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    if (selectedGmb) fetchReviews();
  }, [selectedGmb]);

  const fetchLocations = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${domain()}/gmb/gmb/list`, {
        headers: { Authorization: `Bearer ${Accesstoken}` },
      });
      const json = await res.json();
      if (res.ok && json.status) setLocations(json.data);
    } catch {
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoading(false);
    }
  };

  const fetchReviews = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${domain()}/gmb/review/${btoa(selectedGmb)}`,
        { headers: { Authorization: `Bearer ${Accesstoken}` } }
      );
      const json = await res.json();
      if (res.ok && json.status){
        setReviews(json.data)
      }else{
        ErrorToastContainer(json.message);
      }
    } catch {
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoading(false);
    }
  };

  const ReviewReply = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${domain()}/gmb/review/${btoa(selectedGmb)}`,
        { headers: { Authorization: `Bearer ${Accesstoken}` } }
      );
      const json = await res.json();
      if (res.ok && json.status){
        setReviews(json.data)
      }else{
        ErrorToastContainer(json.message);
      }
    } catch {
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="card p-3">
      {loading && <Loader />}

      <h5 className="mb-3">📍 Google Reviews</h5>

      <select
        className="form-select mb-4"
        onChange={(e) => setSelectedGmb(e.target.value)}
      >
        <option value="">Select Google My Business Account</option>
        {locations.map((loc, i) => (
          <option key={i} value={loc.value}>
            {loc.label}
          </option>
        ))}
      </select>

      {reviews.map((row) => {
        const review = JSON.parse(row.reviews);
        const reviewReply = JSON.parse(row.reviews_replay);
        return <ReviewCard key={row.id} id={row.id} review={review} reply={reviewReply} Store_code={selectedGmb}/>;
      })}

      {!loading && reviews.length === 0 && selectedGmb && (
        <p className="text-center text-muted">No reviews found</p>
      )}
    </div>
  );
}

